import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'guides-view',
  path: (params: { guideSlug: string }) => `/guides/${params.guideSlug}`,
}

export default ROUTE
